export enum DefaultPerPageViewerStates {
  MIN = 25,
  MID = 50,
  MAX = 100,
}
